import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "@/components/ui/card";
import { WebhookManagementPanel } from "@/components/webhooks/panels/webhook-management-panel";
import { useTranslations } from "next-intl";

export function WebhooksSettingsSection({ formId }: { formId: string }) {

	const t = useTranslations("formSettings");	return (
		<Card
			aria-labelledby="webhooks-title"
			className="shadow-none"
			role="region"
			style={{
				overscrollBehavior: "contain",
			}}
		>
			<CardHeader>
				<div className="flex items-center justify-between">
					<div>
						<CardTitle
							className="flex items-center gap-2 text-lg tracking-tight"
							id="webhooks-title"
						>
							{t("webhooksTitle")}
						</CardTitle>
						<CardDescription>
							{t("sendSubmissions")}
						</CardDescription>
					</div>
				</div>
			</CardHeader>
			<CardContent className="flex flex-col gap-6">
				<WebhookManagementPanel formId={formId} />
			</CardContent>
		</Card>
	);
}
